import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    picture: {
      margin: 0,
      padding: 0,
      marginTop: 10,
      width: '125px',
      height: '125px',
      cursor: 'pointer',
      borderRadius: '1em',
    },
    documentIcon: {
      margin: 0,
      padding: 0,
      marginTop: 10,
      width: '125px',
      height: '125px',
      cursor: 'pointer',
      borderRadius: '1em',
      color: 'white',
      '&:hover':{
        color:'gray'
      },
    },
    documentsStyle: {
      display: "flex",
      flexDirection: "column",
      padding: "1em",
    },
    documentsChild: {
      boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
      transition: 'all 200ms ease-in-out',
      '&:hover':{
        background: "rgb(14, 37, 79) !important",
        boxShadow: "rgba(0, 0, 0, 0.35) 5px 10px 25px",
        cursor: "pointer"
      }
    },
    documentsAudio: {
      padding: '1em',
      borderRadius: '1em',
      background: '#203c71',
      margin: '0.5em',
      boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
      transition: 'all 200ms ease-in-out',
      '&:hover':{
        background: "#142f64",
        boxShadow: "rgba(0, 0, 0, 0.35) 5px 10px 25px",
      },
      '&>div':{
        '&>p':{
          color : "#fff"
        }
      }
    },
    labelTicket : {
        fontFamily: "Poppins, sans-serif",
        fontStyle: "normal",
        fontWeight: '500',
        fontSize: '13px',
        lineHeight: '19px',
        alignItems: "center",
        order: 1,
        flexGrow: '0',
        margin: '0px 8px',
        padding: '0.5em',
        background: 'rgba(217, 49, 138, 0.5)',
        borderRadius: '0.5em',
        color: '#fff',
        wordBreak: "break-all",
      },
  }))

export default useStyles
